import { SecuredClient } from 'Core/Api/SecuredClient';
import {
    Account,
    AccountFilterRequest,
    GetSharePoolsByOfferingIdQueryRequest,
    IWebApplicationModel,
    OrderBy,
    SlimOffering,
    GetOfferingsByFilterForCustomerQueryRequest,
    GetOfferingsByIdForCustomerQueryRequest,
    IGetOfferingsViewModelByIdForCustomerQueryRequest,
    GetOfferingsViewModelByIdForCustomerQueryRequest,
    GetApplicationByIdForCustomerQueryRequest,
    GetJointHoldersForAccountRequest,
    GetPaymentMethodDescriptionCommandRequest,
    GetSharesAvailableForApplicationQueryRequest,
    CreateFiservPaymentCommandRequest,
} from 'Core/Api/Api';
import Utility from 'Core/Utility';
import ITableDataFetcher from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataFetcher';
import TableRequest from 'Core/TableUtility/Models/TableRequest';
import ITableDataResponse from 'components/Forms/DataGrid/SimpleTable/Models/ITableDataResponse';

export class ClientIpoHandler implements ITableDataFetcher<SlimOffering> {

    props: any;
    constructor(props) {
        this.props = props;
    }

    GetData(tableRequest: TableRequest): Promise<ITableDataResponse<SlimOffering>> {
        return this.GetOfferings();
    }

    GetOfferingViewModelById(request: IGetOfferingsViewModelByIdForCustomerQueryRequest) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const offeringRequest = new GetOfferingsViewModelByIdForCustomerQueryRequest(request);
        return client.getOfferingsViewModelByIdForCustomer(offeringRequest);
    }


    GetApplicationById(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new GetApplicationByIdForCustomerQueryRequest();
        request.id = id;

        return client.getApplicationByIdForCustomer(request);
    }

    GetJointHoldersForAccount(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetJointHoldersForAccountRequest();
        request.id = id;

        return client.getJointHoldersForAccount(request);
    }
    
    GetFiservInfo(applicationNumber: string | undefined, chargeTotal: number | undefined, currencyCode: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new CreateFiservPaymentCommandRequest();
        request.chargeTotal = chargeTotal;
        request.currencyCode = currencyCode;
        request.applicationNumber = applicationNumber

        return client.getFiservUrl(request);
    }

    GetAccounts() {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new AccountFilterRequest();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getAccounts(request);
    }


    GetAvailableShares(accountId: string | undefined, sharepoolId: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetSharesAvailableForApplicationQueryRequest();
        request.accountId = accountId;
        request.sharePoolId = sharepoolId;

        return client.getSharesAvailableForApplication(request);
    }

    GetOfferings() {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetOfferingsByFilterForCustomerQueryRequest();
        request.amountPerPage = 500;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Name', ascending: true }));

        return client.getOfferingsByFilterForCustomer(request);
    }


    GetOfferingsForDashboard() {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetOfferingsByFilterForCustomerQueryRequest();
        request.amountPerPage = 3;
        request.orderBy = [];
        request.orderBy.push(new OrderBy({ field: 'Status', ascending: true }));
        request.orderBy.push(new OrderBy({ field: 'OpeningDate', ascending: false }));

        return client.getOfferingsByFilterForCustomer(request);
    }

    GetOfferingsById(id: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        const request = new GetOfferingsByIdForCustomerQueryRequest();
        request.id = id;

        return client.getOfferingsByIdForCustomer(request);
    }

    GetSharePools(offeringId: string | undefined) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetSharePoolsByOfferingIdQueryRequest();
        request.offeringId = offeringId;
        return client.getSharePoolsByOfferingId(request);
    }

    CreateOfferingApplication(request: IWebApplicationModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.processSubscription(requestAsFormData as any);
    }

    SaveDraftApplication(request: IWebApplicationModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.saveDraftApplication(requestAsFormData as any);
    }


    EditOfferingApplication(request: IWebApplicationModel) {
        const client = new SecuredClient();
        client.showLoading = true;
        client.handleGeneralError = true;
        const requestAsFormData = Utility.ConvertToFormData(request);
        return client.editApplication(requestAsFormData as any);
    }



    GetPaymentTypes(currency?: string) {
        const client = new SecuredClient();
        client.showLoading = false;
        client.handleGeneralError = true;

        const request = new GetPaymentMethodDescriptionCommandRequest();
        request.currency = currency;
        return client.getPaymentMethodDescription(request);
    }
}
